import React from "react";
import styled from '@emotion/styled';
import IconPackage from 'xiv-fanfes-2021';
import * as breakpoint from '../../styles/breakpoints.module.scss';
import * as config from '../../styles/config.module.scss';


const H2 = styled.h2`
font-weight: 900;
font-size: 48px;
line-height: 56px;
letter-spacing: 0.05em;
color: #2C2C2E;

html[lang="de"] &{
  font-size:40px;
}

@media only screen and (max-width: ${breakpoint.smMax}){
  font-size: 36px;
  line-height: 48px;
  letter-spacing: 0.03em;

  html[lang="de"] &{
    font-size:36px;
  }
}
@media only screen and (max-width: ${breakpoint.xsMax}){
  font-size: 24px;
  line-height: 32px;
  html[lang="de"] &{
    font-size:24px;
  }
}
`

const H3 = styled.h3`
font-weight: 900;
font-size: 18px;
line-height: 24px;
letter-spacing: 0.03em;
color: #787880;
margin-top:16px;
@media only screen and (max-width: ${breakpoint.smMax}){
  font-size: 14px;
line-height: 20px;
}
@media only screen and (max-width: ${breakpoint.xsMax}){
  font-size: 12px;
line-height: 16px;
margin-top:8px;
}
`

const HeadlineWrapper = styled.div`
  margin-bottom:48px;
  width: 100%;
  text-align:${props => props.align};
  @media only screen and (max-width: ${breakpoint.smMax}){
    margin-bottom:48px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin-bottom:16px;
  }
`;

const HeadlineIconWrapper = styled.div`
width:64px;height:64px;
margin:0 auto 16px;
color: ${props => props.color ? '#000000' : props.color};
svg{width:100%;height:100%;}

@media only screen and (max-width: ${breakpoint.smMax}){
  width:56px;height:56px;margin-bottom:12px;
  
}

@media only screen and (max-width: ${breakpoint.xsMax}){
  width:48px;height:48px;margin-bottom:8px;
}
`

const HeadlineIcon = (props) => <HeadlineIconWrapper color={props.color} {...props}><IconPackage.Icon type={props.type} {...props}/></HeadlineIconWrapper>

const P = styled.div`
font-size: 16px;
line-height: 200%;
color: #444448;

text-align:${props => props.align};

@media only screen and (max-width: ${breakpoint.xsMax}){
  font-size: 13px;
}
`

const Ul = styled.ul`
  font-size:${config.fontSizeNormal};
  line-height: 24px;
  margin-left:24px;
  list-style-type:none;
  li{
    color: ${props => props.color ? props.color : '#444448'};
    margin-bottom:6px;
    position:relative;
    &:before{
      top:.75em;
      margin-top:-2px;
      content:' ';
      display:block;
      position:absolute;
      left:-14px;
      width:4px;
      height:4px;
      border-radius:2px;
      background:${props => props.color ? props.color : '#444448'};
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 12px;
    line-height: 20px;
  }

`

const WhiteCard = styled.div`
background: #FFFFFF;
box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
width:768px;
padding:${props => props.narrow === "true" ? '48px' : '96px 80px'};
margin:-50px auto;

text-align:center;

.red{
  color:#D00F31;
}

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:auto;
    margin:-26px auto  32px;
    padding:${props => props.narrow === "true" ? '32px' : '64px 48px'};
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin:-32px auto 0;
    padding:24px 16px;
  }
`

const Anchor = (props) => {
  return (<AnchorWrapper href="#" onClick={(e) => {e.preventDefault();}} {...props}>{props.children}</AnchorWrapper>);
}
 

const AnchorWrapper = styled.a`
  width:0;
  height:0;
  overflow:hidden;
  font-size:0;
  text-indent:-9999px;
  display:block;
`




export {H2, H3 , P ,Ul, HeadlineWrapper, HeadlineIcon,WhiteCard, Anchor}
